import { Chip } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { Body2 } from '../../themes/typography';

const options = [
    { id: 1, name: 'Radio1' },
    { id: 2, name: 'Radio2' },
    { id: 3, name: 'Radio3' }
];

export default function MuiRadioChip({
    radioOptions = options,
    selectedRadioValue,
    setSelectRadioValue,
    disabled = false
}) {
    return (
        <>
            {radioOptions.map(({ id, name }) => {
                const radioChecked = selectedRadioValue?.id === id;

                return (
                    <Chip
                        clickable
                        key={id}
                        onClick={() => setSelectRadioValue({ id, name })}
                        label={
                            <Body2
                                color={radioChecked ? 'var(--primary-color)' : 'var(--quaternary-color)'}
                                fontWeight={radioChecked ? 500 : 300}
                            >
                                {name}
                            </Body2>
                        }
                        deleteIcon={
                            radioChecked ? (
                                <Cancel sx={{ color: 'var(--primary-color) !important' }} />
                            ) : null
                        }
                        onDelete={
                            radioChecked ? () => setSelectRadioValue(null) : undefined
                        }
                        sx={{
                            cursor: radioChecked ? 'default' : 'pointer',
                            pointerEvents: radioChecked ? 'none' : 'auto',
                            border: '1px solid var(--secondary-color)',
                            backgroundColor: radioChecked ? 'var(--secondary-color)' : 'transparent',
                            '&:hover': {
                                backgroundColor: radioChecked ? 'var(--secondary-color)' : 'transparent',
                            },
                            color: 'white',
                            width: 'auto',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '5px 10px',
                            '& .MuiChip-deleteIcon': {
                                pointerEvents: id === 1 && name === 'Date: Closest To Furthest'
                                    ? 'none'
                                    : 'auto',
                                cursor: disabled ? 'not-allowed' : 'pointer',
                                width: 'auto',
                                color: 'var(--primary-color)',
                                fontSize: '1.175rem',
                                margin: '0px',
                                borderRadius: '50%',
                                transition: 'all 0.2s'
                            },
                            '& .MuiChip-deleteIcon: hover': {
                                color: 'white'
                            },
                            '& .MuiChip-label': {
                                color: 'var(--primary-color)',
                                padding: '0px',
                                margin: '0px'
                            }
                        }}
                    />
                );
            })}
        </>
    );
}